import { CreateInstance } from "./config"
const SecurityAgreementAPI = CreateInstance("security-agreement")
export default SecurityAgreementAPI
